module.exports = __webpack_public_path__ + "static/media/glanz.8031ef43.jpg";